/**
 * Backend route that exchanges a bearer token for a session cookie (POST) or
 * ends that session (DELETE). Sessions are only for pages the browser loads
 * straight from the backend, so tokens never need to go in URLs.
 */
export const AuSessionPath = '/api/auth/session';

/** Backend route serving the job queue admin UI (bull-board). Needs a session. */
export const AuJobQueuesAdminPath = '/api/job-queues/admin';

/** Backend route serving the MCP server (Streamable HTTP, POST only). */
export const AuMcpPath = '/mcp';

/** OAuth 2.0 Protected Resource Metadata (RFC 9728) for the MCP server. */
export const AuProtectedResourceMetadataPath =
  '/.well-known/oauth-protected-resource';
